const initializeGameAdmin = (root = document) => {
    /*
     * Plugin-Komponenten für Administration und Moderation.
     */
};

export {
    initializeGameAdmin,
};
